import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllSaleorderTypeResponseModel, SaleorderTypeResponseModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { SaleorderTypeAdapter } from './dto/sale-order-type.adapter';
import { SaleorderTypeDTO } from './dto/sale-order-type.dto';
import { SaleorderType } from './sale-order-type.entity';

@Injectable()
export class SaleOrderTypeService {
  
    constructor(
        @InjectRepository(SaleorderType)
        private saleorderTypeRepository: Repository<SaleorderType>,
        private saleorderTypeAdapter: SaleorderTypeAdapter,
      ){}
      async getSaleorderTypeWithoutRelations(saleorderType: string): Promise<SaleorderType>{
        const SaleorderTypeResponse = await this.saleorderTypeRepository.findOne({
          where: {saleorderType: Raw(alias => `sale_order_type = '${saleorderType}'`)},
        });
        if(SaleorderTypeResponse){
          return SaleorderTypeResponse;
        }
        else{
          return null;
        }
      }
  
      async createSaleorderType(saleorderTypeDTO: SaleorderTypeDTO, isUpdate: boolean): Promise<SaleorderTypeResponseModel>{
  
        // const response = new SaleorderTypeResponseModel();
        // const response = new AllGradesResponseModel(true,1,'Grades retrieved successfully',gradesDtos);

        try{
        const saleorderTypeDtos: SaleorderTypeDTO[] = [];

          if(!isUpdate){
            const SaleorderTypeEntity = await this.getSaleorderTypeWithoutRelations(saleorderTypeDTO.saleOrderTypeName);
            if (SaleorderTypeEntity){
              throw new ErrorResponse(11104, 'Sale Order Type already exists'); 
            }
          }else {
            const SaleorderTypeEntity = await this.getSaleorderTypeWithoutRelations(saleorderTypeDTO.saleOrderTypeName);
            if (SaleorderTypeEntity){
              if(SaleorderTypeEntity.saleorderTypeId!=saleorderTypeDTO.saleorderTypeId){
                throw new ErrorResponse(11104, 'Sale Order Type already exists'); 
              }
            }
          }
          const convertedSaleorderTypeEntity: SaleorderType = this.saleorderTypeAdapter.convertDtoToEntity(saleorderTypeDTO,isUpdate);

          console.log(convertedSaleorderTypeEntity);
        const savedSaleorderTypeEntity: SaleorderType = await this.saleorderTypeRepository.save(convertedSaleorderTypeEntity);
        const savedSaleorderTypeDto: SaleorderTypeDTO = this.saleorderTypeAdapter.convertEntityToDto(savedSaleorderTypeEntity);
        saleorderTypeDtos.push(savedSaleorderTypeDto)
          console.log(savedSaleorderTypeDto);
        if (savedSaleorderTypeDto) {
          //generating resposnse
          const response = new SaleorderTypeResponseModel(true,1,'Sale order type retrieved successfully',saleorderTypeDtos);
          return response;
        } else {
          //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
          throw new ErrorResponse(11106,'Sale Order type saved but issue while transforming into DTO');
        }
        
      } catch (error) {
        // when error occures while saving the data , the execution will come to catch block.
        // tslint:disable-next-line: typedef
        throw error;
      }
    }
    async getAllSaleorderType(): Promise<AllSaleorderTypeResponseModel> {
      // const page: number = 1;
      // const response = new AllSaleorderTypeResponseModel();
      try {
        const saleorderTypeDTO: SaleorderTypeDTO[] = [];
        //retrieves all companies
        const SaleorderTypeEntity: SaleorderType[] = await this.saleorderTypeRepository.find({order :{'saleorderTypeId':'ASC'}});
        //console.log(statesEntities);
        if (SaleorderTypeEntity) {
          // converts the data fetched from the database which of type companies array to type StateDto array.
          SaleorderTypeEntity.forEach(SaleorderTypeEntity => {
            const convertedSaleorderTypeDto: SaleorderTypeDTO = this.saleorderTypeAdapter.convertEntityToDto(
                SaleorderTypeEntity
            );
            saleorderTypeDTO.push(convertedSaleorderTypeDto);
          });
  
          //generated response
          const response = new AllSaleorderTypeResponseModel(true,1,'Sale Order types retrieved successfully',saleorderTypeDTO);
          return response;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
        // return response;
      } catch (err) {
        throw err;
      }
    }  
    async getAllActiveSaleorderType(): Promise<AllSaleorderTypeResponseModel> {
      // const page: number = 1;
      try {
          const saleorderTypeDTO: SaleorderTypeDTO[] = [];
          //retrieves all companies
          const SaleorderTypeEntities: SaleorderType[] = await this.saleorderTypeRepository.find({ order: { 'saleorderType': 'ASC' },
         });
       console.log(SaleorderTypeEntities)
          if (SaleorderTypeEntities) {
              // converts the data fetched from the database which of type companies array to type StateDto array.
              SaleorderTypeEntities.forEach(SaleorderTypeEntity => {
                  const convertedSaleorderTypeDto: SaleorderTypeDTO = this.saleorderTypeAdapter.convertEntityToDto(
                    SaleorderTypeEntity
                  );
                  saleorderTypeDTO.push(convertedSaleorderTypeDto);
              });
              const response = new AllSaleorderTypeResponseModel(true, 11108, "SaleorderType retrieved successfully", saleorderTypeDTO);
              return response;
          } else {
              throw new ErrorResponse(99998, 'Data not found'); saleorderTypeDTO
          }
      } catch (err) {
          throw err;
      }
  }
}

